<p-toast></p-toast>
<div class="card">
  <ng-container *ngIf="dataTable.length > 0; else no_survey_found">
    <p-table
      [loading]="isLoading"
      #surveyTable
      [columns]="dataColumn"
      [value]="dataTable"
      dataKey="id"
      styleClass="p-datatable-responsive-demo"
      [paginator]="true"
      [rows]="5"
      [showCurrentPageReport]="true"
      currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
      [rowsPerPageOptions]="[5, 10, 50]"
      [globalFilterFields]="['startAt', 'status', 'completedPercentage']"
    >
      <ng-template pTemplate="caption">
        <div class="p-d-flex">
          <span class="p-input-icon-left p-ml-auto">
            <i class="pi pi-search"></i>
            <input
              pInputText
              type="text"
              (input)="surveyTable.filterGlobal($event.target.value, 'contains')"
              placeholder="Search.."
            />
          </span>
        </div>
      </ng-template>
      <ng-template pTemplate="header" let-columns>
        <tr>
          <th>Name</th>
          <th>Start At</th>
          <th>End At %</th>
          <th>Status</th>
          <th>Percentage</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-rowData>
        <tr *ngIf="rowData.surveyRef | docRef | async as survey" (click)="getSelectedUserSurveyQuestion(rowData)">
          <td>{{ survey.name }}</td>
          <td>{{ rowData.startAt * 1000 | date: 'shortDate' }}</td>
          <td>{{ rowData.endAt * 1000 | date: 'shortDate' }}</td>
          <td>{{ rowData.status }}</td>
          <td>%{{ rowData.completedPercentage }}</td>
        </tr>
      </ng-template>
    </p-table>
  </ng-container>
  <ng-template #no_survey_found>
    <div class="noProductFound d-flex-col d-flex-centre">
      <span>No user data found with the given name.</span>
      <img src="../../../assets/images/core/not-found.png" />
    </div>
  </ng-template>
</div>
